// extracted by mini-css-extract-plugin
export default {"wrap":"MKW3jVs2_SUKSV7ZrWyR","details":"Ic8V9AON2Q11eV5PUJe9"};